export default {
    punchLog: 'Punch Log',
    searchByEmployeeNoOrName: 'Search by Employee No or Name',
    search: 'Search',
    employeeNo: 'Employee No',
    employeeName: 'Name - Surname',
    date: 'Date',
    time: 'Time',
    startDate: 'Start Date',
    endDate: 'End Date'
}
